/* eslint-disable */

import React from "react";
import styled from "styled-components";
import GlobalStyles from "../Styles/Index";
import { SimpleTextInput } from "../Input/Index";

const NormalText = styled.div`
  font-family: Helvetica;
  font-size: 1rem;
  text-align: left;
  opacity: 0.6;
  padding: 5px 0px 5px 0px;
`;

const FlexedWrapper = styled.div`
  width: ${(props) => (props.width ? props.width : "48%")};
`;

const LocationForm = () => {

  return (
    <>
      <Wrapper>
        <NormalText>This is your billing country and region</NormalText>
        <FlexedWrapper
          width={"100%"}
          style={{ ...GlobalStyles.HorizontalFlex }}
        >
          <FlexedWrapper width={"90%"}>
            <FlexedWrapper
              width={"90%"}
              style={{ ...GlobalStyles.HorizontalFlex }}
            >
              <NormalText>From</NormalText>{" "}
              <SimpleTextInput width={"65%"} placeholder={"Nigeria"} />
            </FlexedWrapper>
            <FlexedWrapper
              width={"90%"}
              style={{ ...GlobalStyles.HorizontalFlex }}
            >
              <NormalText>To</NormalText>{" "}
              <SimpleTextInput width={"65%"} placeholder={"United States"} />
            </FlexedWrapper>
          </FlexedWrapper>
          <FlexedWrapper width={"90%"}>
            <FlexedWrapper
              width={"90%"}
              style={{ ...GlobalStyles.HorizontalFlex }}
            >
              <NormalText>City</NormalText>{" "}
              <SimpleTextInput width={"65%"} placeholder={"Lagos Island"} />
            </FlexedWrapper>
            <FlexedWrapper
              width={"90%"}
              style={{ ...GlobalStyles.HorizontalFlex }}
            >
              <NormalText>Zip Code</NormalText>{" "}
              <SimpleTextInput width={"65%"} placeholder={"2601011"} />
            </FlexedWrapper>
          </FlexedWrapper>
        </FlexedWrapper>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  border-radius: 10px;
  background-color: #d9d9d933;
  padding: 25px 10px 25px 10px;
  width: 100%;
  margin: 2vh 0px 2vh 0px;
`;

export default LocationForm;
